import { googleLogin } from '../components/google-login';
import { facebookLogin } from '../components/facebook-login';

googleLogin();
facebookLogin();
